import { SubjectAreaNames } from '../../../interfaces/EOAInterface';
import { TranscriptPrintData, TranscriptPrintError } from '../../../interfaces/TranscriptsInterface';
import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import { ACADEMIC_PERIODS_LABELS, ACADEMIC_PERIODS_NAMES } from '../../../constants';
import TranscriptPrintViewCell from './TranscriptPrintViewCell';
import { trimTo2Decimals } from '../../../utils';

import './TranscriptPrintView.css';

interface TranscriptPrintViewProps {
  transcript: TranscriptPrintData | TranscriptPrintError;
  subjectAreas: SubjectAreaNames[];
}
function TranscriptPrintView({ transcript, subjectAreas }: TranscriptPrintViewProps) {

  if (transcript.type === 'error') return <p className="page">Student {transcript.studentNumber}'s data is unavailable!</p>;

  let data = transcript.data;

  return (
    <div className="page">
      <div className="print-view-header">
        <p className="student-number">Student {data.school_student_number}</p>
        <div className="student-info">
          <p className="no-margin"><span className="bolded">GPA</span> {trimTo2Decimals(data.gpa)}</p>
          <p className="no-margin"><span className="bolded">Credits</span> {data.credits.toString().toLowerCase()}</p>
          <p className="no-margin"><span className="bolded">Gender</span> {data.gender.toLowerCase()}</p>
          <p className="no-margin"><span className="bolded">Race/ethnicity</span> {data.race.toLowerCase()}</p>
          <p className="no-margin"><span className="bolded">Disability status</span> {data.student_with_disabilities.toLowerCase()}</p>
          <p className="no-margin"><span className="bolded">English language learner status</span> {data.english_learner.toLowerCase()}</p>
          <p className="no-margin"><span className="bolded">Low Income</span> {data.low_income == null ? 'N/A' : data.low_income.toLowerCase()}</p>
        </div>
      </div>
      <TableContainer>
        <Table className="print-view-subject-area-table">
          <TableHead>
            <TableRow>
              <TableCell className="header-cell grade-cell"></TableCell>
              <TableCell className="header-cell semester-cell"></TableCell>
              { subjectAreas.map(subjectArea => {
                let subjectAreaCreditsCount = 0;
                data.academic_periods.forEach(academicPeriod => {
                  academicPeriod.terms.forEach(term => {
                    let subjectAreaData = term.subject_areas.find(subjectAreaDetails => subjectAreaDetails.name === subjectArea);

                    if (subjectAreaData) subjectAreaCreditsCount += subjectAreaData.num_credits;
                  });
                });
                return (
                  <TableCell key={subjectArea} className="header-cell dynamic" sx={{ width: `${88/subjectAreas.length}%`, minWidth: 50 }}>
                    <div className="header-cell-content">
                      <p className="no-margin subject-area-name">{subjectArea}</p>
                      <p className="no-margin regular subject-area-credits">{subjectAreaCreditsCount} credits</p>
                    </div>
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.academic_periods.map((academicPeriod, academicPeriodIndex) => {
              let rowCount = academicPeriod.terms.length;
              let academicPeriodCreditsCount = 0;
              academicPeriod.terms.forEach(term => {
                term.subject_areas.forEach(subjectArea => academicPeriodCreditsCount += subjectArea.num_credits);
              });
              let rows = [];

              for(let rowIndex = 0; rowIndex < rowCount; rowIndex++) {
                if (rowIndex === 0) {
                  rows.push(
                    <TableRow key={`${academicPeriodIndex}-${rowIndex}`} className={`print-view-table-row ${academicPeriodIndex % 2 !== 0 ? 'highlighted' : ''}`}>
                      <TableCell rowSpan={rowCount}>
                        <span className="bolded">{ACADEMIC_PERIODS_LABELS[academicPeriod.period as keyof typeof ACADEMIC_PERIODS_NAMES]}</span>
                        <p className="no-margin">{academicPeriodCreditsCount} credits</p>
                      </TableCell>
                      <TableCell className="border-left">{academicPeriod.terms[rowIndex].name}</TableCell>
                      { subjectAreas.map(subjectArea => (<TranscriptPrintViewCell key={subjectArea} subjectArea={subjectArea} term={academicPeriod.terms[rowIndex]} />))}
                    </TableRow>
                  );
                } else {
                  rows.push(
                    <TableRow key={`${academicPeriodIndex}-${rowIndex}`} className={`print-view-table-row ${academicPeriodIndex % 2 !== 0 ? 'highlighted' : ''}`}>
                      <TableCell className="border-left">{academicPeriod.terms[rowIndex].name}</TableCell>
                      { subjectAreas.map(subjectArea => (<TranscriptPrintViewCell key={subjectArea} subjectArea={subjectArea} term={academicPeriod.terms[rowIndex]} />))}
                    </TableRow>
                  );
                }
              }

              return rows;
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default TranscriptPrintView;
